import { render, staticRenderFns } from "./AcademyList.vue?vue&type=template&id=56037806&scoped=true&lang=pug"
import script from "./AcademyList.vue?vue&type=script&lang=ts"
export * from "./AcademyList.vue?vue&type=script&lang=ts"
import style0 from "./AcademyList.vue?vue&type=style&index=0&id=56037806&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56037806",
  null
  
)

export default component.exports